import { actionChannel, take } from 'typed-redux-saga';
import {
  apiAddDiscountCodeRequested,
  apiAddDiscountCodeRequestedType
} from '@spa/lib/store/api/cart/addDiscountCodeApi';
import {
  apiAddEmployeeDiscountCodesRequested,
  apiAddEmployeeDiscountCodesRequestedType
} from '@spa/lib/store/api/cart/addEmployeeDiscountCodeApi';
import {
  apiAddGiftCardToCartRequested,
  apiAddGiftCardToCartRequestedType
} from '@spa/lib/store/api/cart/addGiftCardToCartApi';
import {
  apiCartAddProductsToCartRequested,
  apiCartAddProductsToCartRequestedType
} from '@spa/lib/store/api/cart/addProductsToCartApi';
import {
  apiCartAddToCartRequested,
  apiCartAddToCartRequestedType
} from '../../../api/cart/addToCartApi';
import {
  apiCartChangeCartBirthDateRequested,
  apiCartChangeCartBirthDateRequestedType
} from '../../../api/cart/changeCartBirthDateApi';
import {
  apiCartChangeCartContactRequested,
  apiCartChangeCartContactRequestedType
} from '../../../api/cart/changeCartContactApi';
import {
  apiCartChangeCartDeliveryAddressRequested,
  apiCartChangeCartDeliveryAddressRequestedType
} from '../../../api/cart/changeCartDeliveryAddressApi';
import {
  apiCartChangeCartDeliveryModeRequested,
  apiCartChangeCartDeliveryModeRequestedType
} from '../../../api/cart/changeCartDeliveryModeApi';
import {
  apiCartChangeCartPaymentAddressRequested,
  apiCartChangeCartPaymentAddressRequestedType
} from '../../../api/cart/changeCartPaymentAddressApi';
import {
  apiCartChangeCartPaymentModeRequested,
  apiCartChangeCartPaymentModeRequestedType
} from '../../../api/cart/changeCartPaymentModeApi';
import {
  apiCartChangeCartStoreRequested,
  apiCartChangeCartStoreRequestedType
} from '@spa/lib/store/api/cart/changeCartStoreApi';
import {
  apiCartChangeCartTypeRequested,
  apiCartChangeCartTypeRequestedType
} from '../../../api/cart/changeCartTypeApi';
import {
  apiCartDeleteCartEntryRequested,
  apiCartDeleteCartEntryRequestedType
} from '../../../api/cart/deleteCartEntryApi';
import {
  apiCartDeleteCartRequested,
  apiCartDeleteCartRequestedType
} from '@spa/lib/store/api/cart/deleteCartApi';
import {
  apiCartReplaceEmailInCartRequested,
  apiCartReplaceEmailInCartRequestedType
} from '../../../api/cart/replaceEmailInCartApi';
import {
  apiCartUpdateCartEntryQuantityRequested,
  apiCartUpdateCartEntryQuantityRequestedType
} from '../../../api/cart/updateCartEntryQuantityApi';
import {
  apiOrdersPlaceOrdersRequested,
  apiOrdersPlaceOrdersRequestedType
} from '../../../api/orders/placeOrdersApi';
import {
  apiRemoveAllDiscountCodesFromCartsRequested,
  apiRemoveAllDiscountCodesFromCartsRequestedType
} from '@spa/lib/store/api/cart/removeAllDiscountCodesFromCartsApi';
import {
  apiRemoveDiscountCodeRequested,
  apiRemoveDiscountCodeRequestedType
} from '@spa/lib/store/api/cart/removeDiscountCodeApi';
import {
  apiRemoveGiftCardFromCartRequested,
  apiRemoveGiftCardFromCartRequestedType
} from '@spa/lib/store/api/cart/removeGiftCardFromCartApi';
import addDiscountCodeSaga from '@spa/lib/store/sagas/api/cart-and-place-order/addDiscountCodeSaga';
import addEmployeeDiscountCodesSaga from '@spa/lib/store/sagas/api/cart-and-place-order/addEmployeeDiscountCodesSaga';
import addGiftCardToCartSaga from '@spa/lib/store/sagas/api/cart-and-place-order/addGiftCardToCartSaga';
import addProductsToCartSaga from './addProductsToCartSaga';
import addToCartSaga from './addToCartSaga';
import { call } from 'typed-redux-saga';
import changeCartBirthDateSaga from './changeCartBirthDateSaga';
import changeCartContactSaga from './changeCartContactSaga';
import changeCartDeliveryAddressSaga from './changeCartDeliveryAddressSaga';
import changeCartDeliveryModeSaga from './changeCartDeliveryModeSaga';
import changeCartPaymentAddressSaga from './changeCartPaymentAddressSaga';
import changeCartPaymentModeSaga from './changeCartPaymentModeSaga';
import changeCartStoreSaga from '@spa/lib/store/sagas/api/cart-and-place-order/changeCartStoreSaga';
import changeCartTypeSaga from './changeCartTypeSaga';
import deleteCartEntrySaga from './deleteCartEntrySaga';
import deleteCartSaga from './deleteCartSaga';
import logger from '../../../../logger';
import placeOrdersSaga from './placeOrdersSaga';
import removeAllDiscountCodesFromCartsSaga from '@spa/lib/store/sagas/api/cart-and-place-order/removeAllDiscountCodesFromCartsSaga';
import removeDiscountCodeSaga from '@spa/lib/store/sagas/api/cart-and-place-order/removeDiscountCodeSaga';
import removeGiftCardFromCartSaga from '@spa/lib/store/sagas/api/cart-and-place-order/removeGiftCardFromCartSaga';
import replaceEmailInCartSaga from './replaceEmailInCartSaga';
import updateCartEntryQuantitySaga from './updateCartEntryQuantitySaga';

// Serializes cart changes
function* watchApiCartSaga(): Generator {
  const requestChan = yield* actionChannel([
    apiAddDiscountCodeRequestedType,
    apiAddEmployeeDiscountCodesRequestedType,
    apiRemoveDiscountCodeRequestedType,
    apiRemoveAllDiscountCodesFromCartsRequestedType,
    apiAddGiftCardToCartRequestedType,
    apiRemoveGiftCardFromCartRequestedType,
    apiCartAddToCartRequestedType,
    apiCartAddProductsToCartRequestedType,
    apiCartUpdateCartEntryQuantityRequestedType,
    apiCartReplaceEmailInCartRequestedType,
    apiCartChangeCartBirthDateRequestedType,
    apiCartChangeCartContactRequestedType,
    apiCartChangeCartDeliveryAddressRequestedType,
    apiCartChangeCartDeliveryModeRequestedType,
    apiCartChangeCartTypeRequestedType,
    apiCartChangeCartPaymentAddressRequestedType,
    apiCartChangeCartPaymentModeRequestedType,
    apiOrdersPlaceOrdersRequestedType,
    apiCartDeleteCartEntryRequestedType,
    apiCartDeleteCartRequestedType,
    apiCartChangeCartStoreRequestedType
  ]);
  while (true) {
    const action = yield* take(requestChan);
    if (apiCartAddToCartRequested.match(action)) {
      yield* call(addToCartSaga, action);
    } else if (apiCartAddProductsToCartRequested.match(action)) {
      yield* call(addProductsToCartSaga, action);
    } else if (apiCartUpdateCartEntryQuantityRequested.match(action)) {
      yield* call(updateCartEntryQuantitySaga, action);
    } else if (apiCartReplaceEmailInCartRequested.match(action)) {
      yield* call(replaceEmailInCartSaga, action);
    } else if (apiCartChangeCartBirthDateRequested.match(action)) {
      yield* call(changeCartBirthDateSaga, action);
    } else if (apiCartChangeCartContactRequested.match(action)) {
      yield* call(changeCartContactSaga, action);
    } else if (apiCartChangeCartDeliveryAddressRequested.match(action)) {
      yield* call(changeCartDeliveryAddressSaga, action);
    } else if (apiCartChangeCartPaymentAddressRequested.match(action)) {
      yield* call(changeCartPaymentAddressSaga, action);
    } else if (apiCartChangeCartDeliveryModeRequested.match(action)) {
      yield* call(changeCartDeliveryModeSaga, action);
    } else if (apiCartChangeCartTypeRequested.match(action)) {
      yield* call(changeCartTypeSaga, action);
    } else if (apiOrdersPlaceOrdersRequested.match(action)) {
      yield* call(placeOrdersSaga, action);
    } else if (apiCartChangeCartPaymentModeRequested.match(action)) {
      yield* call(changeCartPaymentModeSaga, action);
    } else if (apiCartDeleteCartEntryRequested.match(action)) {
      yield* call(deleteCartEntrySaga, action);
    } else if (apiCartDeleteCartRequested.match(action)) {
      yield* call(deleteCartSaga, action);
    } else if (apiCartChangeCartStoreRequested.match(action)) {
      yield* call(changeCartStoreSaga, action);
    } else if (apiAddDiscountCodeRequested.match(action)) {
      yield* call(addDiscountCodeSaga, action);
    } else if (apiAddEmployeeDiscountCodesRequested.match(action)) {
      yield* call(addEmployeeDiscountCodesSaga, action);
    } else if (apiRemoveDiscountCodeRequested.match(action)) {
      yield* call(removeDiscountCodeSaga, action);
    } else if (apiRemoveAllDiscountCodesFromCartsRequested.match(action)) {
      yield* call(removeAllDiscountCodesFromCartsSaga, action);
    } else if (apiAddGiftCardToCartRequested.match(action)) {
      yield* call(addGiftCardToCartSaga, action);
    } else if (apiRemoveGiftCardFromCartRequested.match(action)) {
      yield* call(removeGiftCardFromCartSaga, action);
    } else {
      logger.error('Could not match action [Type: ' + action.type + ']');
    }
  }
}

export default watchApiCartSaga;
